import { Component } from '@angular/core';
import { MeasurementContext } from 'src/app/shared/data/engineering-enums';
import { EngineeringToolsApiService } from 'src/app/shared/services/engineering-tools-api';
import { UnitConverterService } from 'src/app/shared/services/unit-converter.service';
import { ToolBaseComponent } from '../tool-base';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-pressure-safety-valve',
  templateUrl: './pressure-safety-valve.component.html',
  styleUrl: './pressure-safety-valve.component.scss',
  standalone: false
})
export class PressureSafetyValveComponent extends ToolBaseComponent {
  constructor(
    protected override hrtApi: ApiService,
    protected override api: EngineeringToolsApiService,
    protected override unitConverter: UnitConverterService
  ) {
    super(hrtApi, api, unitConverter); 
    this.componentType = "PressureSafetyValve";
  }

  ngOnInit() {
    this.createComponent();
  }

}
